import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchGenericContactList = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        commit('toggleLoadingState', false)
        return false
    } else {
        axios.post('/genericContact/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchGenericContactList', payload)
            } else {
                commit('setGenericContactList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
    
}

export const fetchGenericContactData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/genericContact/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setGenericContactData', {response: res.data.response, copy: payload.copy})   
            dispatch('fetchDocumentList', {contact_id: payload.id, copy: payload.copy})     
            
            dispatch('loadProvinceList', res.data.response.country_id)
            dispatch('loadCityList', res.data.response.province_id)
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }
            
        } else {
            commit('resetGenericContactData')
        }
        dispatch('fetchTaxSetting')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitGenericContactData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/genericContact/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteGenericContactData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/genericContact/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchGenericContactList', {store_list: payload.store_list})
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/genericContact/actions.js